import React from 'react';
import {usePrimaryModal} from "utils";
import {History} from "./history";
import {Svg} from "../../assets";

export const HistoryModal = ({tripId}) => {
    const {closePrimary} = usePrimaryModal();

    return (
        <div className="history-modal-wrappper">
            <div className="modal-header-main">
                <h3 className="modal-header-title">
                    History Details
                </h3>

                <button
                    className="modal-close-btn-main"
                    type="button"
                    onClick={closePrimary}
                    style={{alignSelf: 'flex-start'}}
                >
                    <Svg.CloseSvg/>
                </button>
            </div>

            <History
                currentId={tripId}
                notDescText="No changes have been recorded for this trip yet."
            />
        </div>
    );
};
